import XFetch from '../../common/x-fetch'
import Actions from '../actions'
import SystemActions from '../system/system-actions'
import Utils from '../../common/Utils.js'
import { CONFIG } from '../../config.js'
import { batch } from 'react-redux'

function getUser () {
  return (dispatch) => {
    return XFetch.get(`/api/get_user`)
    .then(result => {
      batch(() => {
        dispatch(_setUser(result.data.user))
        // TODO: do these belong here? we may not be logged in
        dispatch({
          type: Actions.SOCKET,
          types: ['SEND', 'SEND_SUCCESS', 'SEND_FAIL'],
          promise: (socket) => socket.connect()
        })
        dispatch({
          type: Actions.SOCKET,
          types: ['SEND', 'SEND_SUCCESS', 'SEND_FAIL'],// .on or .once?
          promise: (socket) => socket.on('connect_response', result => {
            console.log('- on connect -')
            console.log(result)
          })
        })
      })
    })
    .catch(err => {
      dispatch(SystemActions.handleUserFacingMessages(err))
    })
  }
}

function logout () {
  return (dispatch) => {
    XFetch.get(`/api/logout`)
    .then(result => {
      dispatch({
        type: Actions.USER_CLEAR
      })
    })
    .catch(err => {
      dispatch(SystemActions.handleUserFacingMessages(err))
    })
  }
}

function login (email, password) {
  return (dispatch) => {
    dispatch({
      type: Actions.USER_SET_IS_LOGGING_IN,
      payload: true,
    })
    var login = {email, password}
    return XFetch.post(`/api/login`, login)
    .then(result => {
      let message = ''
      if (result.data.message && result.data.message.text) message = result.data.message.text
      
      batch(() => {
        dispatch(_setUser(result.data.user))
        dispatch({
          type: Actions.USER_SET_LOGIN_RESPONSE,
          payload: message
        })
        dispatch({
          type: Actions.USER_SET_IS_LOGGING_IN,
          payload: false,
        })
      })
    })
    .catch(err => {
      console.log(err)
      batch(() => {
        dispatch({
          type: Actions.USER_SET_LOGIN_RESPONSE,
          payload: 'Login Error'
        })
        dispatch({
          type: Actions.USER_SET_IS_LOGGING_IN,
          payload: false,
        })
      })
    })
  }
}

function _setUser (user) {
  return (dispatch) => {
    dispatch({
      type: Actions.USER_SET_USER,
      payload: user
    })

    if (user) {
      dispatch(SystemActions.getGameTypes())
      dispatch(getFriends())
      dispatch(getGames())
    }
  }
}

function getFriends () {
  return (dispatch) => {
    XFetch.get(`/api/get_friends`)
    .then(result => {
      //console.log(result)
      var friends = Utils.listToDict(result.data.friends)
      dispatch({
        type: Actions.USER_SET_FRIENDS,
        payload: friends
      })
    })
    .catch(err => {
      dispatch(SystemActions.handleUserFacingMessages(err))
    })
  }
}

function getGames () {
  return (dispatch) => {
    XFetch.get(`/api/get_games_by_userid`)
    .then(result => {
      //console.log(result)
      var games = Utils.listToDict(result.data.games)
      dispatch({
        type: Actions.USER_SET_GAMES,
        payload: games
      })
    })
    .catch(err => {
      dispatch(SystemActions.handleUserFacingMessages(err))
    })
  }
}

// this seems a little hardcoded, ad-hoc, and maybe even doesn't belong here
let gameStatusToAction = {
    'INVITE': 'UI_SET_INVITE_TAB',
    'ACTIVE': 'UI_SET_ACTIVE_TAB',
    //'CANCELED': 'CANCELED',
    'COMPLETED': 'UI_SET_PAST_TAB'
  }

function getGameById (gameId) {
  return (dispatch) => {
    XFetch.post(`/api/get_game_by_id`, {'gameId': gameId})
    .then(result => {
      dispatch({
        type: Actions.USER_APPEND_GAME,
        payload: result.data.game,
      })
      if (result.data.game?.status && gameStatusToAction?.[result.data.game.status]) {
        let openAction = gameStatusToAction[result.data.game.status]
        // this is wrong - we need to dispatch the ui-action function
        dispatch({
          type: Actions[openAction],
          payload: true,
        })
      }
    })
    .catch(err => {
      dispatch(SystemActions.handleUserFacingMessages(err))
    })
  }
}

function sendGameInvite (invite) {
  return (dispatch) => {

    XFetch.post(`/api/new_game`, invite)
    .then(result => {
      console.log(result)
      /*
      dispatch({
        type: Actions.SOCKET,
        types: ['SEND', 'SEND_SUCCESS', 'SEND_FAIL'],
        promise: (socket) => socket.on('getGameById', result => {
          console.log('- on getGameById -')
          console.log(result)
        })
      })
      */
    })
    .catch(err => {
      dispatch(SystemActions.handleUserFacingMessages(err))
    })
  }
}

function requestPwReset (email) {
  return (dispatch) => {
    dispatch({
      type: Actions.USER_SET_IS_LOGGING_IN,
      payload: true,
    })
    return XFetch.post(`/api/request_pw_reset`, {email})
    .then(result => {
      batch(() => {
        dispatch({
          type: Actions.USER_SET_LOGIN_RESPONSE,
          payload: result.data.message.text
        })
        dispatch({
          type: Actions.USER_SET_IS_LOGGING_IN,
          payload: false,
        })
      })
    })
    .catch(err => {
      console.log(err)
      batch(() => {
        dispatch({
          type: Actions.USER_SET_LOGIN_RESPONSE,
          payload: 'Password Reset Send Error'
        })
        dispatch({
          type: Actions.USER_SET_IS_LOGGING_IN,
          payload: false,
        })
      })
    })
  }
}

function resetPW (email, password, token) {
  return (dispatch) => {
    dispatch({
      type: Actions.USER_SET_IS_LOGGING_IN,
      payload: true,
    })
    return XFetch.post(`/api/reset_pw`, {email, password, token})
    .then(result => {
      batch(() => {
        dispatch({
          type: Actions.USER_SET_LOGIN_RESPONSE,
          payload: result.data.message.text
        })
        dispatch({
          type: Actions.USER_SET_IS_LOGGING_IN,
          payload: false,
        })
      })
    })
    .catch(err => {
      console.log(err)
      batch(() => {
        dispatch({
          type: Actions.USER_SET_LOGIN_RESPONSE,
          payload: 'Password Reset Error'
        })
        dispatch({
          type: Actions.USER_SET_IS_LOGGING_IN,
          payload: false,
        })
      })
    })
  }
}

function setGameInviteStatus (gameId, status) {
  // /set_game_invite_status
  return (dispatch) => {
    let postBody = {
      gameId: gameId,
      inviteStatus: status,
    }
    console.log(postBody)
    return XFetch.post(`/api/set_game_invite_status`, postBody)
    .then(result => {
      console.log(result)
    })
    .catch(err => {
      dispatch(SystemActions.handleUserFacingMessages(err))
    })
  }
}


export default {
  getUser,
  logout,
  login,
  getFriends,
  getGames,
  getGameById,
  requestPwReset,
  resetPW,
  sendGameInvite,
  setGameInviteStatus,
}
